<template>
  <ApplicationLayout>
    <v-container
      fluid
      px-12
      py-6
      v-if="ready"
    >
      <BackTitle
        :to="{
          name: 'tags',
          query: { focus: tag.id }
        }"
        :title="title"
        :subtitle="tagName"
      ></BackTitle>

      <v-card
        class="pa-6 mt-6"
      >
        <v-row>
          <v-col
            cols="6"
            offset="3"
          >
            <v-form
              @submit.prevent="submit()"
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="tag.name"
                label="Name"
                :rules="rules.name"
              ></v-text-field>

              <div class="d-flex">
                <v-spacer></v-spacer>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  type="submit"
                  class="mr-4"
                  depressed
                >Save</v-btn>

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  @click="saveAndGoBack()"
                  depressed
                >Save & Go back</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card>

      <ProductsList
        v-if="tag.id"
        class="mt-12"
        title="Tag products"
        :scope="{ tagId: tag.id }"
      ></ProductsList>
    </v-container>
  </ApplicationLayout>
</template>

<script>
import { mapState } from 'vuex'
import ApplicationLayout from '../components/layouts/ApplicationLayout.vue'
import BackTitle from '../components/BackTitle.vue'
import ProductsList from '../components/ProductsList.vue'

export default {
  components: {
    ApplicationLayout,
    BackTitle,
    ProductsList
  },
  data() {
    return {
      valid: false,
      ready: false,
      editMode: !!this.$route.params.id,
      rules: {
        name: [v => !!v || 'Name is required']
      }
    }
  },
  computed: {
    ...mapState('Tags', ['tag', 'tagName']),
    title() {
      return this.editMode ? 'Tag' : 'Create new tag'
    }
  },
  async created() {
    await this.getTag(this.$route.params.id)
    this.ready = true
  },
  methods: {
    async getTag(id) {
      await this.$store.dispatch('Tags/get', id)
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      const snackbar = { text: 'Tag update succeed' }
      try {
        await this.$store.dispatch('Tags/createOrUpdate')
        if (!this.editMode) {
          this.$router.push({ name: 'tag', params: { id: this.tag.id } })
          snackbar.text = 'Tag creation succeed'
          this.editMode = true
        }
      } catch (error) {
        snackbar.text = this.editMode ? 'Tag update failed' : 'Tag creation failed'
        snackbar.color = 'error'
      }
      this.$store.commit('Global/setSnackbar', snackbar)
    },
    async saveAndGoBack() {
      await this.submit()
      this.$router.push({ name: 'tags' })
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.name === from.name && to.params.id !== from.params.id) {
      await this.getTag(to.params.id)
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (from.name !== 'new-tag') {
      this.$store.commit('Tags/setTag', null)
      this.$store.commit('Products/setProducts', null)
    }
    next()
  }
}
</script>
